import { render, staticRenderFns } from "./VerifySeller.vue?vue&type=template&id=f704622a&scoped=true&"
import script from "./VerifySeller.vue?vue&type=script&lang=js&"
export * from "./VerifySeller.vue?vue&type=script&lang=js&"
import style0 from "./VerifySeller.vue?vue&type=style&index=0&id=f704622a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f704622a",
  null
  
)

export default component.exports